import React, { useEffect, useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../components/ui/dialog';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/table';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { api } from '../utils/api';
import { Plus, Building2 } from 'lucide-react';
import { toast } from 'sonner';

export const Companies = () => {
  const [companies, setCompanies] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [companyName, setCompanyName] = useState('');

  useEffect(() => {
    fetchCompanies();
  }, []);

  const fetchCompanies = async () => {
    try {
      const response = await api.getCompanies();
      setCompanies(response.data);
    } catch (error) {
      toast.error('Error al cargar empresas');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.createCompany({ name: companyName });
      toast.success('Empresa creada');
      setDialogOpen(false);
      setCompanyName('');
      fetchCompanies();
    } catch (error) {
      toast.error('Error al crear empresa');
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-4xl lg:text-5xl font-bold tracking-tight flex items-center gap-3">
            <Building2 className="h-10 w-10" className="text-blue-600 dark:text-blue-400" />
            Empresas
          </h1>
          <p className="text-base text-slate-600 dark:text-slate-300 mt-2">Gestiona las empresas del sistema</p>
        </div>
        <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
          <DialogTrigger asChild>
            <Button variant="primary" size="default" data-testid="add-company-button">
              <Plus className="h-4 w-4 mr-2" />
              Nueva Empresa
            </Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Nueva Empresa</DialogTitle>
            </DialogHeader>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="name">Nombre de la Empresa *</Label>
                <Input
                  id="name"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  required
                  data-testid="company-name-input"
                />
              </div>
              <div className="flex justify-end gap-2">
                <Button type="button" variant="outline" onClick={() => { setDialogOpen(false); setCompanyName(''); }} variant="secondary" size="default">
                  Cancelar
                </Button>
                <Button type="submit" className="rounded-md border-2 border-slate-300 hover:bg-slate-100 font-medium" className="bg-blue-600 hover:bg-blue-700 text-white font-semibold shadow-md" data-testid="save-company-button">
                  Crear
                </Button>
              </div>
            </form>
          </DialogContent>
        </Dialog>
      </div>

      <Card className="border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900">
        <CardHeader>
          <CardTitle>Lista de Empresas</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="uppercase tracking-wider text-xs">Nombre</TableHead>
                  <TableHead className="uppercase tracking-wider text-xs">Fecha de Creación</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {companies.map((company) => (
                  <TableRow key={company.id} className="hover:bg-slate-50 dark:hover:bg-slate-900">
                    <TableCell className="font-medium">{company.name}</TableCell>
                    <TableCell className="font-mono text-sm">
                      {new Date(company.created_at).toLocaleDateString()}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          {companies.length === 0 && (
            <div className="text-center py-8 text-muted-foreground">
              No hay empresas registradas
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};